/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Something_Went_Wrong_Please_Try_AgainInputs */

const en_toast_something_went_wrong_please_try_again = /** @type {(inputs: Toast_Something_Went_Wrong_Please_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const nl_toast_something_went_wrong_please_try_again = /** @type {(inputs: Toast_Something_Went_Wrong_Please_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is iets misgegaan. Probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Toast_Something_Went_Wrong_Please_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_something_went_wrong_please_try_again = /** @type {((inputs?: Toast_Something_Went_Wrong_Please_Try_AgainInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Something_Went_Wrong_Please_Try_AgainInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_something_went_wrong_please_try_again(inputs)
	return en_toast_something_went_wrong_please_try_again(inputs)
});